import request from './index';

export function getDetails(params) {
  return request.get('officialPageObject/list', {
    params: params
  });
}

